export default function AlertsService($http, $q, $rootScope, appSettings, toastr, gettextCatalog) {
  'ngInject';
  var alertsEndpoint = appSettings.InReachApiAlertsEndpoint + '/occurrences';
  return {
    // repository
    getAllAlerts: function(equipmentId, priority, status) {
      var q = '';
      if (equipmentId) {
        q = '?equipmentId=' + equipmentId;
      }
      if (priority && status && q.length > 0) {
        q += '&priority=' + priority + '&status=' + status;
      }
      if (priority && status && q === '') {
        q = '?priority=' + priority + '&status=' + status;
      }

      if (equipmentId || priority || status) {
        return $http.get(alertsEndpoint + '/active/lite' + q);
      }

      return $http.get(alertsEndpoint + '/active/lite');
    },
    getAlertAggregate: function() {
      return $http.get(alertsEndpoint + '/activecount');
    },
    getAlert: function(alertId) {
      return $http.get(alertsEndpoint + '/' + alertId);
    },
    getAllAlertHistory: function(data) {
      return $http.post(alertsEndpoint, data);
    },
    getAlertHistoryDetails: function(alertId) {
      return $http.get(alertsEndpoint + '/' + alertId + '/details');
    },
    updateAlert: function(alertId, singleAlert) {
      return $http.put(alertsEndpoint + '/' + alertId, singleAlert);
    },
    createNote: function(alertId, note) {
      return $http.post(alertsEndpoint + '/' + alertId + '/notes', note);
    },
    deleteNote: function(alertId, noteId, note) {
      return $http({
        method: 'DELETE',
        url: alertsEndpoint + '/' + alertId + '/notes/' + noteId,
        data: note,
        headers: {
          'Content-Type': 'application/json'
        }
      });
    },
    updateNote: function(alertId, noteId, note) {
      return $http.put(alertsEndpoint + '/' + alertId + '/notes/' + noteId, note);
    },
    getNote: function(alertId) {
      return $http.get(alertsEndpoint + '/' + alertId + '/note');
    },
    getNotes: function(alertId) {
      return $http.get(alertsEndpoint + '/' + alertId + '/notes');
    },
    getAllRules: function() {
      return $http.get(appSettings.InReachApiAlertRulesEndpoint + '/all');
    },
    getAlertCount: function() {
      return $http.get(alertsEndpoint + '/count');
    },
    getRuleById: function(ruleID) {
      return $http.get(appSettings.InReachApiAlertRulesEndpoint + '/' + ruleID);
    },
    updateAlertAcknowledge: updateAlertAcknowledge,
    updateAlertClear: updateAlertClear,

    ////// service
    removeAlert: removeAlert,
    clearAlert: clearAlert,
    acknowledgeAlert: acknowledgeAlert
  };

  ////repository
  function updateAlertAcknowledge(instanceid) {
    return $q(function(resolve, reject) {
      $http.post(alertsEndpoint + '/' + instanceid + '/acknowledge').then(
        function(response) {
          resolve(response);
        },
        function(response) {
          toastr.error(
            gettextCatalog.getString('An error occured while acknowledging the alert. Please try again later.'),
            gettextCatalog.getString('Error')
          );
          reject(response);
        }
      );
    });
  }

  function updateAlertClear(instanceId) {
    return $q(function(resolve, reject) {
      $http.post(alertsEndpoint + '/' + instanceId + '/clear').then(
        function(response) {
          resolve(response);
        },
        function(response) {
          toastr.error(
            gettextCatalog.getString('An error occured while clearing the alert. Please try again later.'),
            gettextCatalog.getString('Error')
          );
          reject(response);
        }
      );
    });
  }

  ///service
  function removeAlert(alert, alerts) {
    var elementPos = alerts
      .map(function(x) {
        return x.attributes.instanceId;
      })
      .indexOf(alert.attributes.instanceId);

    if (elementPos != -1) {
      alerts.splice(elementPos, 1);
    }
  }

  function clearAlert(alert, alerts) {
    return this.updateAlertClear(alert.attributes.instanceId).then(() => removeAlert(alert, alerts));
  }

  function acknowledgeAlert(alert) {
    return updateAlertAcknowledge(alert.attributes.instanceId).then(() => {
      alert.attributes.updatedBy = $rootScope.currentUser.email;
      alert.attributes.status = 'Acknowledged';
    });
  }
}
